export default [
    {id: "text", name: 'Текст'},
    {id: 'single-select', name: 'Один из списка'}
]